// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2VWyk","actions":"GroupTable_actions__1rjGT","deleteModalFooter":"GroupTable_deleteModalFooter__1YQG2"};